import { useCallback, useEffect, useState } from 'react'
import { motivosPerdaService } from '@/services/motivosPerdaService'
import { MotivoPerda } from '@/types/scoreComercial'

/**
 * Catálogo de motivos de perda (decisão 8.6) para quem precisa escolher um (diálogo) ou
 * traduzir um código em rótulo (detalhe, histórico). Carrega quando `ativo` vira true;
 * falha é estado visível, não silêncio — sem catálogo o usuário não consegue marcar a
 * perda, e precisa saber por quê.
 */
export const useMotivosPerda = (ativo: boolean = true) => {
  const [motivos, setMotivos] = useState<MotivoPerda[]>([])
  const [carregando, setCarregando] = useState(false)
  const [erro, setErro] = useState<string | null>(null)

  const carregar = useCallback(async () => {
    setCarregando(true)
    setErro(null)
    try {
      setMotivos(await motivosPerdaService.listar())
    } catch (e) {
      setErro((e as { message?: string })?.message ?? 'Não foi possível carregar os motivos de perda')
    } finally {
      setCarregando(false)
    }
  }, [])

  useEffect(() => {
    if (ativo) void carregar()
  }, [ativo, carregar])

  /**
   * Rótulo do catálogo; código desconhecido (ex.: `REPROVACAO_ORIGINEI`, que não é
   * selecionável e por isso não vem na lista) volta como está — nunca um texto inventado.
   */
  const rotuloDe = useCallback(
    (codigo: string | null | undefined): string | null => {
      if (!codigo) return null
      return motivos.find((m) => m.codigo === codigo)?.rotulo ?? codigo
    },
    [motivos],
  )

  return { motivos, carregando, erro, recarregar: carregar, rotuloDe }
}
